


export function exportWorkZones(uuid, mainZones, sideZones) {

    let result = '';

    result += '{\n';
    result += '"uuid": "' + uuid + '",\n';
    result += '"last_change": ' + Math.round(Date.now() / 1000) + ',\n';

    result += '"main_path_segments":[\n';
    result += mainZones.map(poly => '[' + poly.map(p => '[' + p.lat + ',' + p.lng + ']').join(',') + ']').join(',\n');
    result += '],\n';

    result += '"side_paths":[\n';
    result += sideZones.map(poly => '[' + poly.map(p => '[' + p.lat + ',' + p.lng + ']').join(',') + ']').join(',\n');
    result += '\n]\n';

    result += '}\n';

    return result;
}